// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Ticket Header & Layout ── */
.ticket-header {
  position: relative;
  height: auto;
}

.ticket-info-card {
  top: 0;
  background: var(--color-white);
  border: 1px solid var(--color-border-light);
}

.ticket-info-card .card-body {
  height: auto;
  overflow: visible;
}

.ticket-content {
  height: auto;
  padding-right: 8px;
}

.ticket-divider {
  margin: 10px 0;
  border-top: 1px solid #ccc;
}

/* ── Tabs ── */
.ticket-tab-hdr {
  border-bottom: 2px solid #e5e7eb;
  background: var(--color-white);
  padding: 0 20px 0 0;
}

.ticket-tab {
  padding: 12px 24px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 700;
  font-size: .9rem;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-family: inherit;
}

.ticket-tab:hover {
  color: var(--color-primary-orange);
  background: #fff7ed;
}

.ticket-tab.selected {
  color: var(--color-primary-orange);
  border-bottom-color: var(--color-primary-green);
  font-weight: 700;
}

/* ── Compact form spacing ── */
.form-label {
  font-size: 13px;
  margin-bottom: 4px;
}

.form-control,
select {
  font-size: 13px;
  padding: 4px 6px;
}

/* ── Messages Table ── */
.message-table-header th {
  background: var(--color-bg-hover);
  color: #495057;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #dee2e6;
}

.msg-time {
  font-size: 12px;
  color: var(--color-icon-muted);
}

.msg-from {
  font-weight: 600;
  color: var(--color-primary-green);
}

.msg-to {
  font-weight: 600;
  color: #495057;
}

.message-body img {
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  margin: 6px 0;
}

.blur-background {
  filter: blur(4px);
  transition: filter 0.2s ease-in-out;
}

/* ── Quill Wrappers ── */
.quill-wrapper {
  height: 160px;
  width: 100%;
}

.quill-wrapper .ql-toolbar.ql-snow {
  display: block;
  border: 1px solid #ced4da;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  background: var(--color-white);
  z-index: 1;
}

.quill-wrapper .ql-container.ql-snow {
  height: 120px !important;
  border: 1px solid #ced4da;
  border-radius: 0 0 4px 4px;
  overflow-y: auto;
}

.quill-wrapper .ql-editor {
  height: 120px !important;
  overflow-y: auto;
}

.ticket-quill-wrapper {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
}

.ticket-quill-wrapper .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid #ccc;
}

.ticket-quill-wrapper .ql-container.ql-snow {
  border: none !important;
  overflow: hidden !important;
}

.ticket-quill-wrapper .ql-editor {
  min-height: 150px;
  max-height: 500px;
  overflow-y: auto;
  resize: vertical;
}

/* ── Solution ── */
.solution-template-select {
  position: relative;
  z-index: 1055;
  margin-bottom: 10px;
}

.solution-editor .ql-container {
  min-height: 120px;
}

/* ── Send Message Modal ── */
.modal-minimize-btn {
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  color: #666;
  margin-right: 4px;
  -webkit-user-select: none;
          user-select: none;
}
.modal-minimize-btn:hover { color: #333; }

.modal-close-btn {
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  color: #666;
  -webkit-user-select: none;
          user-select: none;
}
.modal-close-btn:hover { color: #333; }

.send-message-minimized-bar {
  position: fixed;
  bottom: 0;
  right: 20px;
  width: 280px;
  background: var(--color-primary-orange);
  color: var(--color-white);
  padding: 8px 16px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1050;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.2);
  font-size: 14px;
}
.send-message-minimized-bar:hover { background: #23272b; }
.send-message-minimized-close { font-size: 18px; line-height: 1; }

.modal-minimized-backdrop .modal-backdrop { display: none !important; }
.modal-minimized-backdrop { overflow: auto !important; padding-right: 0 !important; }

/* ── Icon Buttons (zoom, download etc.) ── */
.icon-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.icon-btn:hover {
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.icon-btn i { font-size: 14px; }

.icon-btn-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Floating Action Button ── */
.floating-action-button {
  position: fixed;
  bottom: 100px;
  right: 40px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
}

.floating-action-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.floating-action-button i { color: var(--color-white); font-size: 24px; }

.floating-button-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #e74c3c;
  color: var(--color-white);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid var(--color-white);
}

/* ── Side Panel ── */
.side-panel-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  animation: fadeIn 0.3s ease;
}

.side-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 450px;
  height: 100vh;
  background: var(--color-white);
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.3s ease;
}

.side-panel-header {
  padding: 19px 22px;
  background: linear-gradient(135deg,var(--color-primary-green) 0%, var(--color-primary-green) 100%);
  color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.side-panel-header h5 { font-weight: 600; font-size: 18px; }

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: var(--color-white);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-btn:hover { background: rgba(255, 255, 255, 0.3); transform: scale(1.1); }

.side-panel-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* ── Insights ── */
.insight-section { margin-bottom: 16px; }

.insight-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

.insight-section-header h6 { font-size: 14px; font-weight: 600; color: #333; }

.insight-badge {
  background: var(--color-primary-green);
  color: var(--color-white);
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 24px;
  text-align: center;
}

.insight-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;
}

.insight-card {
  border: 2px solid #d0d0d0;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: var(--color-white);
}

.insight-card:hover {
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
  transform: translateY(-2px);
}

.insight-card .card-body { padding: 12px; }

.ticket-link { color: var(--color-primary-green); font-weight: 600; font-size: 13px; text-decoration: none; }
.ticket-link:hover { text-decoration: underline; }
.ticket-date { color: #999; font-size: 11px; }
.ticket-title { font-size: 13px; color: #333; margin-bottom: 8px; font-weight: 500; }
.ticket-meta { display: flex; gap: 12px; font-size: 11px; color: #666; }
.meta-item strong { color: #333; }

.view-more-btn {
  width: 100%;
  padding: 10px;
  background-color: var(--color-bg-hover);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color:var(--color-primary-green);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.view-more-btn:hover { background-color: #e9ecef; border-color:var(--color-primary-green); }
.view-more-btn i { font-size: 12px; }

/* ── Workflow Tabs ── */
.workflow-tab-hdr {
  border-bottom: 2px solid #e5e7eb;
  background: var(--color-white);
  padding: 0 20px 0 0;
}

.workflow-tab {
  width: 233px;
  padding: 10px 20px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-family: inherit;
  display: flex;
}
.workflow-tab:hover { color: var(--color-primary-orange); background: #fff7ed; }
.workflow-tab.selected { color: var(--color-primary-orange); border-bottom-color: var(--color-primary-orange); background-color: #f8e7d8ff; }

.workflow-overflow-dots {
  color:var(--color-primary-orange);
  cursor: pointer;
  font-size: 20px;
  padding: 6px 10px;
  -webkit-user-select: none;
          user-select: none;
  margin-left: -20px;
}
.workflow-overflow-dots:hover { background-color: #fff7ed; }

/* ── Table hover ── */
.table tbody tr { transition: background-color 0.2s ease, box-shadow 0.2s ease; }
.table tbody tr:hover {
  background-color: rgba(255, 127, 14, 0.06);
  box-shadow: inset 4px 0 0 var(--color-primary-orange);
}

/* ── Cell alignment ── */
.cell-center-align { display: flex !important; justify-content: center !important; align-items: center !important; }
.cell-left-align { display: flex !important; justify-content: flex-start !important; align-items: center !important; }

/* ── Custom scrollbar ── */
.custom-scrollbar::-webkit-scrollbar { width: 1px; }
.custom-scrollbar::-webkit-scrollbar-track { background: var(--color-white); }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #bdbdbd; border-radius: 10px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #9e9e9e; }
.custom-scrollbar { scrollbar-width: thin; }

.insight-cards::-webkit-scrollbar { width: 6px; }
.insight-cards::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
.insight-cards::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
.insight-cards::-webkit-scrollbar-thumb:hover { background: #555; }

/* ── Animations ── */
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }

@media (max-width: 768px) {
  .side-panel { width: 100%; }
}
/* ── Internal Notes ── */
.note-section-title {
  font-weight: 600;
  margin-bottom: 0;
}

.note-show-toggle {
  cursor: pointer;
  font-weight: 600;
  color: var(--color-icon-muted);
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.note-toggle-icon {
  font-size: 12px;
}

.note-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 8px;
  position: relative;
}

.note-meta {
  min-width: 160px;
  max-width: 160px;
}

.note-author {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.note-time {
  font-size: 12px;
  color: var(--color-icon-muted);
}

.note-eye-wrap {
  padding-top: 2px;
  position: relative;
}

.note-eye-icon {
  color: var(--color-primary-orange);
  cursor: pointer;
  font-size: 14px;
}

.note-text-clamp {
  flex: 1 1;
  font-size: 13px;
  color: #212529;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Note Tooltip */
.note-tooltip {
  position: absolute;
  z-index: 1050;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: 340px;
  background: #f0fafa;
  border: 1px solid var(--color-primary-green);
  border-left: 4px solid var(--color-primary-green);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.15);
  padding: 16px;
}

.note-tooltip-arrow-border {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--color-primary-green);
}

.note-tooltip-arrow {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #f0fafa;
}

.note-tooltip-name {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 4px;
}

.note-tooltip-date {
  font-size: 12px;
  color: var(--color-icon-muted);
  margin-bottom: 10px;
}

.note-tooltip-divider {
  margin: 8px 0;
}

.note-tooltip-body {
  font-size: 13px;
  color: #212529;
  line-height: 1.6;
  white-space: pre-line;
  word-break: break-word;
}

.note-tooltip-updated {
  font-size: 11px;
  color: #adb5bd;
  margin-top: 10px;
}
.note-table {
  border: 1px solid #495057;
  border-radius: 8px;
  overflow: visible;
}

.note-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 8px;
  position: relative;
  border-bottom: 1px solid #e9ecef;
}

.note-row:first-child {
  border-radius: 8px 8px 0 0;  /* keeps rounded corners on first row */
}

.note-row:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;  /* keeps rounded corners on last row */
}

/* ── CC Recipients Column ── */
.cc-recipients {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.cc-badge {
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.cc-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsive: Hide CC column on mobile */
@media (max-width: 768px) {
  .cc-column {
    display: none;
  }
}

/* Tablet: Show CC column but with smaller width */
@media (min-width: 769px) and (max-width: 1024px) {
  th.cc-column,
  td.cc-column {
    width: 140px !important;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .detailsPageHeader .dropdown-toggle {
    width: 100% !important;
  }

  .detailsPageHeader .dropdown-menu {
    width: 100% !important;
  }

  .detailsPageHeader > .col-md-3 {
    max-width: 100%;
    flex: 1 1 100%;
    order: 2;
  }

  .detailsPageHeader > [class*="gx-0"] {
    flex: 1 1 auto;
    order: 3;
  }

  .detailsPageHeader .default-btn-color {
    width: 100%;
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader .col.d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 8px;
  }

  .detailsPageHeader .breadcrumb-wrapper {
    width: 100%;
    order: 1;
  }

  .detailsPageHeader .header-actions {
    width: 100%;
    justify-content: flex-end;
    order: 2;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .detailsPageHeader .col-auto {
    padding: 0 !important;
  }

  .detailsPageHeader .col-auto .gx-0 {
    margin-right: 6px !important;
    margin-bottom: 6px;
  }

  .detailsPageHeader button,
  .detailsPageHeader .btn {
    margin: 0 4px 6px 0 !important;
  }
}
 .ticket-selected-badge {
  background: var(--primary);
  color: var(--primary-text);
  border-radius: 20px;
  padding: 2px 10px;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}
/* ── Orange link icons (SAP/District/Region/Company) ── */
.location-link-icon {
  color: var(--color-primary-green);
  font-size: 14px;
  cursor: pointer;
}

/* ── Store Visit text link ── */
.store-visit-link {
  font-size: 12px;
  color: var(--color-primary-orange);
  cursor: pointer;
  text-decoration: underline;
}

/* ── Employee search external-link round button ── */
.emp-search-btn {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: var(--color-primary-green);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.avatar-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #0bb5d4;
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}
.message-bubble {
  max-width: 75%;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.message-bubble--me {
  background: #d1f8ff;
  border: 2px solid #0bb5d4;
}

.message-bubble--other {
  background: #f1f1f1;
  border: 2px solid #ddd;
}
.eye-icon {
  color: var(--color-primary-orange);
}

.attachment-badge {
  background-color: rgba(10, 118, 116, 0.12);
  color: var(--color-primary-green);
  font-weight: 600;
  border-radius: 12px;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.history-table-header {
  color: var(--color-primary-orange);
}
.insight-header-icon {
  color: var(--color-primary-orange);
  font-size: 20px;
}

.insight-close-btn {
  background-color: var(--color-primary-orange);
  color: var(--color-white);
}

.insight-section-icon {
  color: var(--color-primary-orange);
}
.workflow-arrow-icon {
  color: var(--color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/ticketing/components/Ticketing.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,MAAM;EACN,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,4BAA4B,WAAW,EAAE;;AAEzC;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,yBAAyB,WAAW,EAAE;;AAEtC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,eAAe;AACjB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,gCAAgC,eAAe,EAAE,cAAc,EAAE;;AAEjE,4CAA4C,wBAAwB,EAAE;AACtE,4BAA4B,yBAAyB,EAAE,2BAA2B,EAAE;;AAEpF,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA,cAAc,eAAe,EAAE;;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,4BAA4B,yBAAyB,EAAE,eAAe,EAAE;;AAExE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oCAAoC;EACpC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kGAAkG;EAClG,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB,gBAAgB,EAAE,eAAe,EAAE;;AAE3D;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;AACA,mBAAmB,oCAAoC,EAAE,qBAAqB,EAAE;;AAEhF;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,6BAA6B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAE7E;EACE,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,2BAA2B,aAAa,EAAE;;AAE1C,eAAe,iCAAiC,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC5G,qBAAqB,0BAA0B,EAAE;AACjD,eAAe,WAAW,EAAE,eAAe,EAAE;AAC7C,gBAAgB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACpF,eAAe,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,WAAW,EAAE;AACvE,oBAAoB,WAAW,EAAE;;AAEjC;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA,uBAAuB,yBAAyB,EAAE,uCAAuC,EAAE;AAC3F,mBAAmB,eAAe,EAAE;;AAEpC,wBAAwB;AACxB;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;AACf;AACA,sBAAsB,kCAAkC,EAAE,mBAAmB,EAAE;AAC/E,yBAAyB,kCAAkC,EAAE,gDAAgD,EAAE,2BAA2B,EAAE;;AAE5I;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,gCAAgC,yBAAyB,EAAE;;AAE3D,sBAAsB;AACtB,kBAAkB,4DAA4D,EAAE;AAChF;EACE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,yBAAyB;AACzB,qBAAqB,wBAAwB,EAAE,kCAAkC,EAAE,8BAA8B,EAAE;AACnH,mBAAmB,wBAAwB,EAAE,sCAAsC,EAAE,8BAA8B,EAAE;;AAErH,2BAA2B;AAC3B,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,8BAA8B,EAAE;AAC7E,6CAA6C,yBAAyB,EAAE,mBAAmB,EAAE;AAC7F,mDAAmD,yBAAyB,EAAE;AAC9E,oBAAoB,qBAAqB,EAAE;;AAE3C,oCAAoC,UAAU,EAAE;AAChD,0CAA0C,mBAAmB,EAAE,mBAAmB,EAAE;AACpF,0CAA0C,gBAAgB,EAAE,mBAAmB,EAAE;AACjF,gDAAgD,gBAAgB,EAAE;;AAElE,qBAAqB;AACrB,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,0BAA0B,OAAO,2BAA2B,EAAE,EAAE,KAAK,wBAAwB,EAAE,EAAE;;AAEjG;EACE,cAAc,WAAW,EAAE;AAC7B;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,iDAAiD;EACjD,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B,GAAG,uCAAuC;AACtE;;AAEA;EACE,mBAAmB;EACnB,0BAA0B,GAAG,sCAAsC;AACrE;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;AACF;;AAEA,kDAAkD;AAClD;EACE;;IAEE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,QAAQ;EACV;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;;IAEE,8BAA8B;EAChC;AACF;CACC;EACC,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,0DAA0D;AAC1D;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC","sourcesContent":["/* ── Ticket Header & Layout ── */\n.ticket-header {\n  position: relative;\n  height: auto;\n}\n\n.ticket-info-card {\n  top: 0;\n  background: var(--color-white);\n  border: 1px solid var(--color-border-light);\n}\n\n.ticket-info-card .card-body {\n  height: auto;\n  overflow: visible;\n}\n\n.ticket-content {\n  height: auto;\n  padding-right: 8px;\n}\n\n.ticket-divider {\n  margin: 10px 0;\n  border-top: 1px solid #ccc;\n}\n\n/* ── Tabs ── */\n.ticket-tab-hdr {\n  border-bottom: 2px solid #e5e7eb;\n  background: var(--color-white);\n  padding: 0 20px 0 0;\n}\n\n.ticket-tab {\n  padding: 12px 24px;\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  font-weight: 700;\n  font-size: .9rem;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  font-family: inherit;\n}\n\n.ticket-tab:hover {\n  color: var(--color-primary-orange);\n  background: #fff7ed;\n}\n\n.ticket-tab.selected {\n  color: var(--color-primary-orange);\n  border-bottom-color: var(--color-primary-green);\n  font-weight: 700;\n}\n\n/* ── Compact form spacing ── */\n.form-label {\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.form-control,\nselect {\n  font-size: 13px;\n  padding: 4px 6px;\n}\n\n/* ── Messages Table ── */\n.message-table-header th {\n  background: var(--color-bg-hover);\n  color: #495057;\n  font-weight: 600;\n  font-size: 13px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.msg-time {\n  font-size: 12px;\n  color: var(--color-icon-muted);\n}\n\n.msg-from {\n  font-weight: 600;\n  color: var(--color-primary-green);\n}\n\n.msg-to {\n  font-weight: 600;\n  color: #495057;\n}\n\n.message-body img {\n  max-width: 120px;\n  max-height: 120px;\n  width: auto;\n  height: auto;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n  margin: 6px 0;\n}\n\n.blur-background {\n  filter: blur(4px);\n  transition: filter 0.2s ease-in-out;\n}\n\n/* ── Quill Wrappers ── */\n.quill-wrapper {\n  height: 160px;\n  width: 100%;\n}\n\n.quill-wrapper .ql-toolbar.ql-snow {\n  display: block;\n  border: 1px solid #ced4da;\n  border-bottom: none;\n  border-radius: 4px 4px 0 0;\n  background: var(--color-white);\n  z-index: 1;\n}\n\n.quill-wrapper .ql-container.ql-snow {\n  height: 120px !important;\n  border: 1px solid #ced4da;\n  border-radius: 0 0 4px 4px;\n  overflow-y: auto;\n}\n\n.quill-wrapper .ql-editor {\n  height: 120px !important;\n  overflow-y: auto;\n}\n\n.ticket-quill-wrapper {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.ticket-quill-wrapper .ql-toolbar.ql-snow {\n  border: none;\n  border-bottom: 1px solid #ccc;\n}\n\n.ticket-quill-wrapper .ql-container.ql-snow {\n  border: none !important;\n  overflow: hidden !important;\n}\n\n.ticket-quill-wrapper .ql-editor {\n  min-height: 150px;\n  max-height: 500px;\n  overflow-y: auto;\n  resize: vertical;\n}\n\n/* ── Solution ── */\n.solution-template-select {\n  position: relative;\n  z-index: 1055;\n  margin-bottom: 10px;\n}\n\n.solution-editor .ql-container {\n  min-height: 120px;\n}\n\n/* ── Send Message Modal ── */\n.modal-minimize-btn {\n  cursor: pointer;\n  font-size: 28px;\n  line-height: 1;\n  color: #666;\n  margin-right: 4px;\n  user-select: none;\n}\n.modal-minimize-btn:hover { color: #333; }\n\n.modal-close-btn {\n  cursor: pointer;\n  font-size: 24px;\n  line-height: 1;\n  color: #666;\n  user-select: none;\n}\n.modal-close-btn:hover { color: #333; }\n\n.send-message-minimized-bar {\n  position: fixed;\n  bottom: 0;\n  right: 20px;\n  width: 280px;\n  background: var(--color-primary-orange);\n  color: var(--color-white);\n  padding: 8px 16px;\n  border-radius: 8px 8px 0 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1050;\n  box-shadow: 0 -2px 8px rgba(0,0,0,0.2);\n  font-size: 14px;\n}\n.send-message-minimized-bar:hover { background: #23272b; }\n.send-message-minimized-close { font-size: 18px; line-height: 1; }\n\n.modal-minimized-backdrop .modal-backdrop { display: none !important; }\n.modal-minimized-backdrop { overflow: auto !important; padding-right: 0 !important; }\n\n/* ── Icon Buttons (zoom, download etc.) ── */\n.icon-btn {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-primary-green);\n  border-color: var(--color-primary-green);\n}\n\n.icon-btn:hover {\n  background-color: var(--color-primary-green);\n  border-color: var(--color-primary-green);\n}\n\n.icon-btn i { font-size: 14px; }\n\n.icon-btn-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── Floating Action Button ── */\n.floating-action-button {\n  position: fixed;\n  bottom: 100px;\n  right: 40px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1000;\n}\n\n.floating-action-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);\n}\n\n.floating-action-button i { color: var(--color-white); font-size: 24px; }\n\n.floating-button-badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: #e74c3c;\n  color: var(--color-white);\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  border: 2px solid var(--color-white);\n}\n\n/* ── Side Panel ── */\n.side-panel-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n  animation: fadeIn 0.3s ease;\n}\n\n.side-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 450px;\n  height: 100vh;\n  background: var(--color-white);\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  animation: slideInRight 0.3s ease;\n}\n\n.side-panel-header {\n  padding: 19px 22px;\n  background: linear-gradient(135deg,var(--color-primary-green) 0%, var(--color-primary-green) 100%);\n  color: var(--color-white);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.side-panel-header h5 { font-weight: 600; font-size: 18px; }\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: var(--color-white);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.close-btn:hover { background: rgba(255, 255, 255, 0.3); transform: scale(1.1); }\n\n.side-panel-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n/* ── Insights ── */\n.insight-section { margin-bottom: 16px; }\n\n.insight-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.insight-section-header h6 { font-size: 14px; font-weight: 600; color: #333; }\n\n.insight-badge {\n  background: var(--color-primary-green);\n  color: var(--color-white);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 12px;\n  min-width: 24px;\n  text-align: center;\n}\n\n.insight-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 16px;\n}\n\n.insight-card {\n  border: 2px solid #d0d0d0;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  background: var(--color-white);\n}\n\n.insight-card:hover {\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n  transform: translateY(-2px);\n}\n\n.insight-card .card-body { padding: 12px; }\n\n.ticket-link { color: var(--color-primary-green); font-weight: 600; font-size: 13px; text-decoration: none; }\n.ticket-link:hover { text-decoration: underline; }\n.ticket-date { color: #999; font-size: 11px; }\n.ticket-title { font-size: 13px; color: #333; margin-bottom: 8px; font-weight: 500; }\n.ticket-meta { display: flex; gap: 12px; font-size: 11px; color: #666; }\n.meta-item strong { color: #333; }\n\n.view-more-btn {\n  width: 100%;\n  padding: 10px;\n  background-color: var(--color-bg-hover);\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  color:var(--color-primary-green);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n}\n.view-more-btn:hover { background-color: #e9ecef; border-color:var(--color-primary-green); }\n.view-more-btn i { font-size: 12px; }\n\n/* ── Workflow Tabs ── */\n.workflow-tab-hdr {\n  border-bottom: 2px solid #e5e7eb;\n  background: var(--color-white);\n  padding: 0 20px 0 0;\n}\n\n.workflow-tab {\n  width: 233px;\n  padding: 10px 20px;\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  font-family: inherit;\n  display: flex;\n}\n.workflow-tab:hover { color: var(--color-primary-orange); background: #fff7ed; }\n.workflow-tab.selected { color: var(--color-primary-orange); border-bottom-color: var(--color-primary-orange); background-color: #f8e7d8ff; }\n\n.workflow-overflow-dots {\n  color:var(--color-primary-orange);\n  cursor: pointer;\n  font-size: 20px;\n  padding: 6px 10px;\n  user-select: none;\n  margin-left: -20px;\n}\n.workflow-overflow-dots:hover { background-color: #fff7ed; }\n\n/* ── Table hover ── */\n.table tbody tr { transition: background-color 0.2s ease, box-shadow 0.2s ease; }\n.table tbody tr:hover {\n  background-color: rgba(255, 127, 14, 0.06);\n  box-shadow: inset 4px 0 0 var(--color-primary-orange);\n}\n\n/* ── Cell alignment ── */\n.cell-center-align { display: flex !important; justify-content: center !important; align-items: center !important; }\n.cell-left-align { display: flex !important; justify-content: flex-start !important; align-items: center !important; }\n\n/* ── Custom scrollbar ── */\n.custom-scrollbar::-webkit-scrollbar { width: 1px; }\n.custom-scrollbar::-webkit-scrollbar-track { background: var(--color-white); }\n.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #bdbdbd; border-radius: 10px; }\n.custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #9e9e9e; }\n.custom-scrollbar { scrollbar-width: thin; }\n\n.insight-cards::-webkit-scrollbar { width: 6px; }\n.insight-cards::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }\n.insight-cards::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }\n.insight-cards::-webkit-scrollbar-thumb:hover { background: #555; }\n\n/* ── Animations ── */\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }\n\n@media (max-width: 768px) {\n  .side-panel { width: 100%; }\n}\n/* ── Internal Notes ── */\n.note-section-title {\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.note-show-toggle {\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--color-icon-muted);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.note-toggle-icon {\n  font-size: 12px;\n}\n\n.note-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 8px;\n  position: relative;\n}\n\n.note-meta {\n  min-width: 160px;\n  max-width: 160px;\n}\n\n.note-author {\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.note-time {\n  font-size: 12px;\n  color: var(--color-icon-muted);\n}\n\n.note-eye-wrap {\n  padding-top: 2px;\n  position: relative;\n}\n\n.note-eye-icon {\n  color: var(--color-primary-orange);\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.note-text-clamp {\n  flex: 1;\n  font-size: 13px;\n  color: #212529;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Note Tooltip */\n.note-tooltip {\n  position: absolute;\n  z-index: 1050;\n  bottom: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: 340px;\n  background: #f0fafa;\n  border: 1px solid var(--color-primary-green);\n  border-left: 4px solid var(--color-primary-green);\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.15);\n  padding: 16px;\n}\n\n.note-tooltip-arrow-border {\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid var(--color-primary-green);\n}\n\n.note-tooltip-arrow {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #f0fafa;\n}\n\n.note-tooltip-name {\n  font-weight: 700;\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.note-tooltip-date {\n  font-size: 12px;\n  color: var(--color-icon-muted);\n  margin-bottom: 10px;\n}\n\n.note-tooltip-divider {\n  margin: 8px 0;\n}\n\n.note-tooltip-body {\n  font-size: 13px;\n  color: #212529;\n  line-height: 1.6;\n  white-space: pre-line;\n  word-break: break-word;\n}\n\n.note-tooltip-updated {\n  font-size: 11px;\n  color: #adb5bd;\n  margin-top: 10px;\n}\n.note-table {\n  border: 1px solid #495057;\n  border-radius: 8px;\n  overflow: visible;\n}\n\n.note-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 8px;\n  position: relative;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.note-row:first-child {\n  border-radius: 8px 8px 0 0;  /* keeps rounded corners on first row */\n}\n\n.note-row:last-child {\n  border-bottom: none;\n  border-radius: 0 0 8px 8px;  /* keeps rounded corners on last row */\n}\n\n/* ── CC Recipients Column ── */\n.cc-recipients {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.cc-badge {\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.cc-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive: Hide CC column on mobile */\n@media (max-width: 768px) {\n  .cc-column {\n    display: none;\n  }\n}\n\n/* Tablet: Show CC column but with smaller width */\n@media (min-width: 769px) and (max-width: 1024px) {\n  th.cc-column,\n  td.cc-column {\n    width: 140px !important;\n  }\n}\n@media (max-width: 768px) {\n  .detailsPageHeader {\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n\n  .detailsPageHeader .dropdown-toggle {\n    width: 100% !important;\n  }\n\n  .detailsPageHeader .dropdown-menu {\n    width: 100% !important;\n  }\n\n  .detailsPageHeader > .col-md-3 {\n    max-width: 100%;\n    flex: 1 1 100%;\n    order: 2;\n  }\n\n  .detailsPageHeader > [class*=\"gx-0\"] {\n    flex: 1 1 auto;\n    order: 3;\n  }\n\n  .detailsPageHeader .default-btn-color {\n    width: 100%;\n    white-space: nowrap;\n  }\n}\n@media (max-width: 768px) {\n  .detailsPageHeader .col.d-flex.justify-content-between {\n    flex-direction: column;\n    align-items: stretch !important;\n    gap: 8px;\n  }\n\n  .detailsPageHeader .breadcrumb-wrapper {\n    width: 100%;\n    order: 1;\n  }\n\n  .detailsPageHeader .header-actions {\n    width: 100%;\n    justify-content: flex-end;\n    order: 2;\n  }\n}\n@media (max-width: 768px) {\n  .detailsPageHeader {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n\n  .detailsPageHeader .col-auto {\n    padding: 0 !important;\n  }\n\n  .detailsPageHeader .col-auto .gx-0 {\n    margin-right: 6px !important;\n    margin-bottom: 6px;\n  }\n\n  .detailsPageHeader button,\n  .detailsPageHeader .btn {\n    margin: 0 4px 6px 0 !important;\n  }\n}\n .ticket-selected-badge {\n  background: var(--primary);\n  color: var(--primary-text);\n  border-radius: 20px;\n  padding: 2px 10px;\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n}\n/* ── Orange link icons (SAP/District/Region/Company) ── */\n.location-link-icon {\n  color: var(--color-primary-green);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* ── Store Visit text link ── */\n.store-visit-link {\n  font-size: 12px;\n  color: var(--color-primary-orange);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/* ── Employee search external-link round button ── */\n.emp-search-btn {\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background: var(--color-primary-green);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.avatar-circle {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: #0bb5d4;\n  color: var(--color-white);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n.message-bubble {\n  max-width: 75%;\n  padding: 15px;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n.message-bubble--me {\n  background: #d1f8ff;\n  border: 2px solid #0bb5d4;\n}\n\n.message-bubble--other {\n  background: #f1f1f1;\n  border: 2px solid #ddd;\n}\n.eye-icon {\n  color: var(--color-primary-orange);\n}\n\n.attachment-badge {\n  background-color: rgba(10, 118, 116, 0.12);\n  color: var(--color-primary-green);\n  font-weight: 600;\n  border-radius: 12px;\n  padding: 4px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.history-table-header {\n  color: var(--color-primary-orange);\n}\n.insight-header-icon {\n  color: var(--color-primary-orange);\n  font-size: 20px;\n}\n\n.insight-close-btn {\n  background-color: var(--color-primary-orange);\n  color: var(--color-white);\n}\n\n.insight-section-icon {\n  color: var(--color-primary-orange);\n}\n.workflow-arrow-icon {\n  color: var(--color-primary-orange);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
